var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('campaign',{attrs:{"audioUrl":_vm.url,"title":_vm.title,"author":_vm.author}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }